import classNames from 'classnames';
import React, { JSX } from 'react';
import EuHostedLogo from 'assets/quickshare/EuHosted';
import IsoLogo from 'assets/quickshare/Iso27001';
import AgencyDriveLogo from 'assets/agency-drive-logo.svg';
import defaultStorroLogo from 'assets/storro-logo-and-text-dark.svg';
import useTheme from 'hooks/UseTheme';

interface Props {
  className?: string;
  includeLogo?: boolean;
  logoSize?: number;
  badgesSize?: number;
}

function FooterBadges({ className, includeLogo = true, logoSize = 80, badgesSize = 30 }: Props): JSX.Element {
  const { isAgencyTheme } = useTheme();

  const logo = isAgencyTheme ? AgencyDriveLogo : defaultStorroLogo;

  return (
    <div className={classNames('flex items-center gap-x-6', className)}>
      {includeLogo && (
        <div className='flex gap-2'>
          <img src={logo} alt='logo' width={logoSize} />
        </div>
      )}
      <div className='flex gap-2'>
        <IsoLogo size={badgesSize} className='text-gray-500' />
      </div>
      <div className='flex gap-2 mr-4'>
        <EuHostedLogo size={badgesSize} className='text-gray-500' />
      </div>
    </div>
  );
}

export default FooterBadges;
